<div class="white-bg-overlay">&nbsp;</div>
<section class="page-wrapper bg-white scroll-container">
  <div class="d-flex">
    <div class="me-auto">
      <h3 class="page-title mb-5">
        <a routerLink="/reports">Corporate Reports</a> > Nightly ACH Fraud Scan
      </h3>
    </div>
    <div class="title-bar-btn" *ngIf="authService.hasPermission('corporate_reports_ach_scan', 'W')">
      <button
        cpGTagEvent
        [params]="{ event_label: 'reports_ach_scan_begin' }"
        class="btn btn-primary"
        [attr.disabled]="!canScan ? 'disabled' : null"
        (click)="beginScan()">
        Begin Scan
      </button>
    </div>
  </div>
  <div *ngIf="scans">
    <table class="table table-border mb-5" style="max-width: 1000px">
      <thead>
        <tr>
          <th>Date</th>
          <th>Status</th>
          <th style="width: 100px" class="text-center">Download</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let scan of scans">
          <td>{{ scan.CreatedOn | date: 'short' }}</td>
          <td>
            <span *ngIf="scan.Status == 4" title="scan.ErrorDescription">
              {{ jobStatus[scan.Status] }}
            </span>
            <span *ngIf="scan.Status != 4">
              {{ jobStatus[scan.Status] }}
            </span>
          </td>
          <td class="text-center">
            <a *ngIf="scan.FileId" (click)="downloadScan(scan.Id)">
              <i class="fa fa-lg fa-download"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <lib-pagination [pagination]="pagination" (pageChanged)="loadPage($event)"></lib-pagination>
  </div>
</section>
